import { useState } from "react";
import Sidebar from "../../components/Sidebar";
import { Close, Menu } from "@mui/icons-material";
import { useLocation, Link, Outlet } from "react-router-dom";

import Logo from "../../images/Logo.png";

const MainScreen = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  // Check if the current route is the login page
  const isLoginPage = location.pathname === "/account/login";

  return (
    <div style={{ display: "flex", height: "100vh", flexDirection: "column" }}>
      <div style={{ display: "flex", flexGrow: 1 }}>
        {!isLoginPage && isSidebarVisible && (
          <Sidebar
            toggleSidebar={toggleSidebar}
            style={{ position: "fixed", top: "60px", left: 0 }}
          />
        )}
        <div style={{ flexGrow: 1, marginLeft: !isLoginPage && isSidebarVisible ? 230 : 0, transition: "margin-left 0.3s" }}>
          <div className="shadow-md w-full px-4 py-3 flex items-center justify-between fixed top-0 z-50 bg-[#6f8ead]">
            {/* Logo and Title */}
            <div className="flex items-center space-x-4 w-full ml-12">
              <Link to='/'>
                <img src={Logo} alt="Gym Management System" className="h-10 w-10 rounded-full" />
              </Link>
              <h1 className="text-xl md:text-2xl font-bold text-gray-800">Gym Management System</h1>
            </div>

            {/* Sidebar Toggle Button */}
            {!isLoginPage && (
              <button onClick={toggleSidebar} className={`absolute top-3 left-[${isSidebarVisible ? 250 : 10}] font-extrabold`}>
                {isSidebarVisible ? <Close className="text-white bg-red-600 rounded-full" /> : <Menu className="text-white bg-green-400 px-1" />}
              </button>
            )}
          </div>
          <div className="mt-16 p-4 bg-white min-h-screen">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainScreen;
